import { format, parseISO } from 'date-fns';

export const formatChatDate = (date) => format(parseISO(date), 'MM/dd, h:mm aaaa');
